export default "__VITE_ASSET__D68UL4xz__"